export const API_GVS = 'https://cajaexpress.gvscolombia.com/api/App';
export const API_IMG = 'https://cajaexpress.gvscolombia.com/api/App/Adjuntos?';
export const API_USER_IMG = 'https://www.gvscolombia.com/rest.gvscolombia.com/RestFull/public/perfil_x_usuario?'
export const ROUTE_IMG ='https://www.gvscolombia.com/rest.gvscolombia.com/RestFull/public/carpetaImagenes/'